"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SessionService = void 0;
var model_1 = require("./model");
var http_1 = require("../../core/http");
var session_api_1 = require("./session.api");
var operators_1 = require("rxjs/operators");
var store_1 = require("./store");
var env_1 = require("../../env");
var session_helper_service_1 = require("./session-helper.service");
var storedSessionId;
var fetchGetSession$;
var fetchCreateSession$;
var fetchGetSession = function (sessionId, options) {
    if (options === void 0) { options = {}; }
    var fetchData = http_1.Http.get(session_api_1.SessionApi.get(sessionId)).pipe(operators_1.map(function (res) { return model_1.createSession(res); }));
    if (options.preventShare) {
        return fetchData;
    }
    if (!fetchGetSession$ || sessionId !== storedSessionId) {
        fetchGetSession$ = fetchData.pipe(operators_1.share());
        storedSessionId = sessionId;
    }
    return fetchGetSession$;
};
var fetchCreateSession = function (body, options) {
    var _a;
    if (body === void 0) { body = {}; }
    if (options === void 0) { options = {}; }
    var stayPeriod = body.context && body.context.stayPeriod;
    var guests = body.context && body.context.guests;
    var display = body.display || {};
    var sessionBody = {
        engineId: env_1.Env.EngineId,
        isMonoHotel: env_1.Env.IsMonoHotel,
        display: {
            culture: display.culture || env_1.Env.DefaultLanguage,
            currency: display.currency || env_1.Env.Currency,
            countryCode: display.countryCode || env_1.Env.Country
        },
        context: {
            stayPeriod: stayPeriod || { arrivalDate: env_1.Env.DefaultArrivalDate, departureDate: env_1.Env.DefaultDepartureDate },
            guests: guests || { adults: env_1.Env.DefaultNumberOfAdults, children: env_1.Env.DefaultNumberOfChildren, infants: env_1.Env.DefaultNumberOfInfants },
            selectedHotelId: env_1.Env.HotelId,
            promoCode: (_a = body.context) === null || _a === void 0 ? void 0 : _a.promoCode
        },
        metadata: env_1.Env.SessionMetadata
    };
    // console.log('session body in fetch', sessionBody);
    var fetchData = http_1.Http.post(session_api_1.SessionApi.create(), sessionBody);
    if (options.preventShare) {
        return fetchData;
    }
    if (!fetchCreateSession$) {
        fetchCreateSession$ = fetchData.pipe(operators_1.share());
    }
    return fetchCreateSession$;
};
var fetchSession = function (sessionId) {
    return fetchGetSession(sessionId).pipe(operators_1.map(function (session) {
        session_helper_service_1.SessionHelperService.storeSession(session);
        return session;
    }), operators_1.catchError(shouldBeSessionError));
};
var getSession = function () {
    if (store_1.SessionQuery.getValue().sessionId) {
        return store_1.SessionQuery.select();
    }
    session_helper_service_1.SessionHelperService.setLoadingInSession(true);
    var paramsSessionId = session_helper_service_1.SessionHelperService.getSessionIdFromParams();
    if (paramsSessionId) {
        return session_helper_service_1.SessionHelperService.fetchSessionAndHandleInvalidError(paramsSessionId);
    }
    var localStorageSessionId = session_helper_service_1.SessionHelperService.getSessionFromLocalStorage();
    if (localStorageSessionId) {
        return session_helper_service_1.SessionHelperService.fetchSessionAndHandleInvalidError(localStorageSessionId);
    }
    var cookieSessionId = session_helper_service_1.SessionHelperService.getSessionFromCookie();
    if (cookieSessionId) {
        return session_helper_service_1.SessionHelperService.fetchSessionAndHandleInvalidError(cookieSessionId);
    }
    return session_helper_service_1.SessionHelperService.createNewSession();
};
var updateContextSession = function (body) {
    var session = store_1.SessionQuery.getValue();
    session_helper_service_1.SessionHelperService.setLoadingInSession(true);
    return store_1.SessionHasRooms$.pipe(operators_1.switchMap(function (hasRooms) {
        return hasRooms
            ? session_helper_service_1.SessionHelperService.fetchUpdateSessionContextWithNotEmptyBasket(__assign(__assign({}, session.context), body), session)
            : session_helper_service_1.SessionHelperService.fetchUpdateSessionContext(session.sessionId, __assign(__assign({}, session.context), body));
    }), operators_1.first(), operators_1.switchMap(function () { return fetchSession(session.sessionId); }), operators_1.catchError(shouldBeSessionError), operators_1.finalize(function () { return session_helper_service_1.SessionHelperService.setLoadingInSession(false); }));
};
var updateDisplaySession = function (body) {
    var session = store_1.SessionQuery.getValue();
    session_helper_service_1.SessionHelperService.setLoadingInSession(true);
    return session_helper_service_1.SessionHelperService.fetchUpdateSessionDisplay(session.sessionId, body).pipe(operators_1.first(), operators_1.switchMap(function () { return fetchSession(session.sessionId); }), operators_1.catchError(shouldBeSessionError), operators_1.finalize(function () { return session_helper_service_1.SessionHelperService.setLoadingInSession(false); }));
};
var shouldBeSessionError = function (err) {
    if (session_helper_service_1.SessionHelperService.isInvalidSession(err)) {
        session_helper_service_1.SessionHelperService.createNewSession().subscribe();
    }
    return http_1.Http.error(err);
};
window.QW_HOTEL_UPDATE_SESSION_DATA = function (session, guests, stayPeriod, promoCode) {
    return updateContextSession(__assign(__assign({}, session.context), { guests: guests, stayPeriod: stayPeriod, promoCode: promoCode })).toPromise();
};
exports.SessionService = {
    getSession: getSession,
    updateContextSession: updateContextSession,
    updateDisplaySession: updateDisplaySession,
    fetchSession: fetchSession,
    fetchGetSession: fetchGetSession,
    fetchCreateSession: fetchCreateSession,
    shouldBeSessionError: shouldBeSessionError
};
//# sourceMappingURL=session.service.js.map